
import { FormsFeatureContext, IDataCollectionResponse } from '@ngt/forms';
import { useCallback, useContext } from 'react';
import { LotProperty, LotPropertyPostBulkEdit } from '../../api/dtos';

// mutate?: KeyedMutator<IDataSingleResponse<LotProperty>>

export const usePostLotPropertyBulkEdit = () => {
    const formsFeature = useContext(FormsFeatureContext);


    // @ts-ignore
    const save = useCallback(async (lotIds?: number[], propertyValues?: PropertyValue[], metadata?: Record<string, any>, shouldRevalidate?: boolean) => {
        if(!lotIds || !propertyValues) return false;
        const response: IDataCollectionResponse<LotProperty> = await formsFeature.serviceStackClient.post(new LotPropertyPostBulkEdit({ lotIds: lotIds, propertyValues: propertyValues}))

        return response?.data;
    }, [formsFeature.serviceStackClient]);

    return save;
};

export default usePostLotPropertyBulkEdit;